import { render, staticRenderFns } from "./FormEmployeeInfo.vue?vue&type=template&id=12b3384a"
import script from "./FormEmployeeInfo.vue?vue&type=script&lang=js"
export * from "./FormEmployeeInfo.vue?vue&type=script&lang=js"
import style0 from "./FormEmployeeInfo.vue?vue&type=style&index=0&id=12b3384a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports